<template>
  <el-header class="root">
    <h1 class="title">AI属性分析</h1>
    <div class="right">
      <span class="time">{{ getTime }}</span>
      <span class="username">ユーザー：{{ username }}</span>
      <el-button class="logout-button" type="default" @click="signOut">ログアウト</el-button>
    </div>
  </el-header>
</template>

<script>

export default {
  name: 'HeaderContent',
  props: {
    username: String
  },

  data() {
    let now = new Date()
    return {
      now: now,
    }
  },

  computed: {
    getTime: function () {
      return this.now.getFullYear() +
        "/" + ('0' + (this.now.getMonth() + 1)).slice(-2) +
        "/" + ('0' + this.now.getDate()).slice(-2) +
        " " + ('0' + this.now.getHours()).slice(-2) +
        ":" + ('0' + this.now.getMinutes()).slice(-2) +
        ":" + ('0' + this.now.getSeconds()).slice(-2)
    }
  },

  created: function () {
    //時計の更新
    setInterval(() => { this.now = new Date() }, 100)
  },

  methods: {
    signOut: async function () {
      try {
        this.$emit("signOut")
      } catch (error) {
        console.log('error signing out: ', error);
      }
    },
  },

}

</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@400&display=swap");
.title {
  font-size: 32px;
  letter-spacing: 0.5rem;
  margin: auto 0;
  font-family: "Zen Kaku Gothic New", sans-serif;
}
.el-header {
  background-color: black;
  color: white;
  line-height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
}
.root {
  display: flex;
  height: 60px;
  font-size: 12px;
}

img {
  width: 50%;
  max-width: 300px;
  max-height: 50px;
  margin: auto 0;
}

.right {
  margin-left: auto;
  display: block;
}

.username {
  padding-left: 20px;
  padding-right: 10px;
  font-size: 14px;
}
</style>
